import React from 'react';
import '../App.css'; // Importing App.css for styling
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-solid-svg-icons';
import { Container, Row, Col, Button } from 'react-bootstrap';

function Contact() {
  return (
    <Container>
      <Row className="justify-content-center">
        <Col xs={12} md={10} lg={8} className="content-section">
          <h1>Kontakta oss</h1>
          <p className="lead">Onytec AB är ett företag som är passionerat för att göra elbilsladdning enklare och mer kostnadseffektivt. Vi strävar efter att ge våra kunder den bästa möjliga upplevelsen.</p>
          <p>Välkommen att kontakta oss om du har frågor om appen, förslag på förbättringar eller andra funderingar.</p>
          <hr />
          <h4>Kontaktinformation</h4>
          <p>
            <strong>E-post:</strong> info@laddvis.se
            <Button
              variant="outline-secondary" 
              size="sm" 
              onClick={() => navigator.clipboard.writeText('info@laddvis.se')}
              className="ms-2 py-0 px-1" 
              title="Kopiera e-postadress"
            >
              <FontAwesomeIcon icon={faCopy} />
            </Button>
          </p>
        </Col>
      </Row>
    </Container>
  );
}

export default Contact;
